import {app} from '../../app';
import IScope = angular.IScope;
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import IComponentController = angular.IComponentController;
import {CheckboxSharedQuestion} from "../../sharedQuestions/CheckboxSharedQuestion";
import {IUniqueIdService} from "../../services/UniqueIdService";

export class CheckboxQuestionComponent {

    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;
    protected uniqueIdService:IUniqueIdService;

    sharedQuestion:CheckboxSharedQuestion;

    nextQuestionCallback;
    question:IQuestion;
    values:(string|boolean)[] = [];
    choices:string[]          = [];
    style:any                 = 'default';
    ids:string[]              = [];

    static $inject = ['SharedQuestionService', 'SessionService', 'UniqueIdService'];

    constructor(sharedQuestionService:SharedQuestionService, sessionService:ISessionService, UniqueId:IUniqueIdService) {
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService        = sessionService;
        this.uniqueIdService       = UniqueId;
    }

    $onInit = () => {
        this.sharedQuestion = new CheckboxSharedQuestion();

        this.setup();
    };

    setup() {
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        this.choices = this.question.meta.choices;

        const style = this.question.meta.style;
        if (style) {
            this.style = style;
        }

        // values and ids
        let index = 0;
        for (const choice of this.choices) {
            this.values.push(false);
            this.ids.push(this.uniqueIdService.getUniqueId('checkbox-question'));
            this.update(index);
            index++;
        }

        // defaults
        const defaults = this.question.meta.default;
        if (defaults) {
            for (const _default of defaults) {
                const index        = this.choices.indexOf(_default);
                this.values[index] = _default;
                this.update(index);
            }
        }

        // answers
        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            for (let value of answer.values) {
                const index = value.choice;
                if (value.value) {
                    this.values[index] = this.choices[index];
                    this.update(index);
                }
            }
        }
    }

    update(index:number) {
        let newValue:IValue = {
            choice: index,
            value : !(!this.values[index])
        };

        this.sharedQuestion.setValue(newValue);
    }

}

app.component('checkboxQuestion', {
    templateUrl : 'templates/components/questionTypes/checkboxQuestion.html',
    controller  : CheckboxQuestionComponent,
    controllerAs: 'checkboxQuestion',
    bindings    : {
        question            : '<',
        nextQuestionCallback: '&'
    }
});